import { useQuery } from '@tanstack/react-query'
import { query } from '../graphql'

export const usePartnerQuery = ({ partner_id }) => {
  return useQuery({
    queryKey: ['partner', partner_id],
    queryFn: () =>
      query({ query: 'getPartner', variables: { id: partner_id } }),
    enabled: !!partner_id
  })
}
